import React from "react";
import PublicHeader from "./PublicHeader";
import PublicFooter from "./PublicFooter";

export default function PublicPage({
  eyebrow,
  title,
  intro,
  children,
}: {
  eyebrow?: string;
  title: string;
  intro?: string;
  children?: React.ReactNode;
}) {
  return (
    <div className="min-h-screen bg-crystal-charcoal">
      <div className="fixed inset-0 bg-[radial-gradient(1200px_600px_at_80%_-20%,rgba(155,135,245,0.15),transparent),radial-gradient(900px_500px_at_-10%_10%,rgba(74,222,128,0.08),transparent)] pointer-events-none" />
      <PublicHeader />
      <main>
        <section className="relative">
          <div className="max-w-6xl mx-auto px-4 pt-16 pb-10 md:pt-20">
            {eyebrow && <p className="app-eyebrow mb-3">{eyebrow}</p>}
            <h1 className="heading-app text-3xl md:text-5xl mb-4">{title}</h1>
            {intro && <p className="text-white/75 max-w-3xl text-lg">{intro}</p>}
          </div>
        </section>
        {children}
      </main>
      <PublicFooter />
    </div>
  );
}
